import React from 'react';
import { Chip } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** Link chip for pages the assistant opened (or offered to open). */
const NavigateCard = ({ navigation }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!navigation?.path) return null;
  const label = navigation.label || navigation.page || navigation.path;
  return (
    <Chip
      size="small"
      variant="outlined"
      color="primary"
      icon={<OpenInNewOutlined fontSize="small" />}
      label={t('assistant.opened', { label })}
      onClick={() => navigate(navigation.path)}
      aria-label={t('assistant.openAria', { label })}
      sx={{ maxWidth: '100%' }}
    />
  );
};

export default NavigateCard;
